import React, {Component} from "react";
import {
    FormField,
    FormSection,
    Hint,
    Input,
    InputLabel,
    SectionBody,
    SectionHeader
} from "aws-amplify-react/dist/Amplify-UI/Amplify-UI-Components-React";
import {I18n} from "aws-amplify";
import {Button, ButtonToolbar, Col, Container, Modal, Row} from "react-bootstrap";
import * as PropTypes from "prop-types";
import Header from "./parts/Header";
import Footer from "./parts/Footer";
import {GeneLifeDict} from "../translate/GeneLife";
import '../Styles/genelife.css';
import '../Styles/subpages.css';

I18n.setLanguage('ja-JP');
I18n.putVocabularies(GeneLifeDict);

export class ConfirmUpdateEccAccountComponents extends Component {
    render() {
        return (
            <div>
            <Header/>
            <FormSection theme={this.props.theme}>
            <SectionHeader theme={this.props.theme}>{I18n.get("Confirm registered Email")}</SectionHeader>
            <SectionBody theme={this.props.theme}>
                <Container>
                    <div className="new_line">
                        <Row>
                            <Hint theme={this.props.theme}>
                                {I18n.get(`あなたの登録メールアドレスは`)}
                                <div className="email_emphasis">{I18n.get(`${this.props.currentEmail}`)}</div>
                                {I18n.get(`で登録されていますがそのままご利用されますか？`)}
                            </Hint>
                        </Row>
                    </div>
                    <div className="new_line">
                        <Row>
                            <Col>
                                <ButtonToolbar>
                                    <Button variant="secondary" onClick={this.props.changeStateFunc}>
                                        {I18n.get("同じメールアドレスを使用")}
                                    </Button>
                                </ButtonToolbar>
                            </Col>
                            <Col>
                                <ButtonToolbar>
                                    <Button variant="info" onClick={this.props.handleShow}>
                                        {I18n.get("メールアドレスを変更する")}
                                    </Button>
                                </ButtonToolbar>
                                <Modal show={this.props.openInput} onHide={this.props.handleClose}>
                                    <Modal.Header closeButton>
                                        <Modal.Title>{I18n.get("メールアドレス変更")} </Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                        <FormField theme={this.props.theme}>
                                            <InputLabel theme={this.props.theme}>{I18n.get("メールアドレス")}</InputLabel>
                                            <Input
                                                // placeholder={I18n.get("(例)aaa@bb.jpl")}
                                                theme={this.props.theme}
                                                key="email"
                                                name="email"
                                                value={this.props.input_email}
                                                onChange={this.props.handleInputChangeCustom}
                                            />
                                            {this.props.email_err_msg}
                                        </FormField>
                                    </Modal.Body>
                                    <Modal.Footer>
                                        <Button variant="secondary" onClick={this.props.handleClose}>
                                            キャンセルする
                                        </Button>
                                        <Button variant="primary" onClick={this.props.changeEmail}>
                                            変更する
                                        </Button>
                                    </Modal.Footer>
                                </Modal>
                            </Col>
                        </Row>
                    </div>
                </Container>
            </SectionBody>
        </FormSection>
        <Footer theme={this.props.theme}/>
        </div>);
    }
}

ConfirmUpdateEccAccountComponents.propTypes = {
    theme: PropTypes.any,
    currentEmail: PropTypes.any,
    changeStateFunc: PropTypes.func,
    handleShow: PropTypes.func,
    openInput: PropTypes.bool,
    handleClose: PropTypes.func,
    input_email: PropTypes.string,
    handleInputChangeCustom: PropTypes.func,
    email_err_msg: PropTypes.any,
    changeEmail: PropTypes.func
};